import type { useEditorStore } from './editor-store'
import type { useViewStore } from './view-store'
import { createContext, use } from 'react'

export interface EditorStore {
  view: ReturnType<typeof useViewStore>
  store: ReturnType<typeof useEditorStore>
}

export const EditorContext = createContext<EditorStore | undefined>(undefined)

export function useEditor(): EditorStore {
  const ctx = use(EditorContext)
  if (!ctx)
    throw new Error('useEditor() called outside <Editor>')
  return ctx
}
